import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/veteran-facing-services-tools/veteran-facing-services-tools/packages/documentation/src/layouts/SidebarLayout.jsx";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "analytics"
    }}>{`Analytics`}</h1>
    <p>{`When creating a new page or new feature there might be a need to add analytics to
capture events on page. In our code base you will find 2 files that relate to analytics.`}</p>
    <ul>
      <li parentName="ul">{`/src/platform/startup/analytics-middleware.js`}</li>
      <li parentName="ul">{`/src/platform/monitoring/record-event.js`}</li>
    </ul>
    <h2 {...{
      "id": "analytics-middlewarejs"
    }}>{`analytics-middleware.js`}</h2>
    <p>{`This file is a plugin for MetalSmith. This is where the google analytics is
initialized. Events will get pushed to a `}<inlineCode parentName="p">{`window.dataLayer`}</inlineCode>{` then evaluated then
sent to our analytics service.`}</p>
    <h2 {...{
      "id": "record-eventjs"
    }}>{`record-event.js`}</h2>
    <p>{`This file is our utility functions for recording analytical events. You will
want to use these functions for recording events on your page. The `}<inlineCode parentName="p">{`recordEvent`}</inlineCode>{`
function will take in an object with an event property like so.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`recordEvent({
  event: 'your-event-name',
})
`}</code></pre>
    <p>{`The event name is determined by your analytics team, so please make sure you
communicate with them to make sure you are using the correct event.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      